import _ from "lodash";
import React from "react";
import requireAuth from "../auth/requireAuth";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { editConta, fetchConta } from "../../actions";
import ContaForm from "./ContaForm";

class ContaEdit extends React.Component {
  componentDidMount() {
    this.props.fetchConta(this.props.match.params.id);
  }

  onSubmit = (formValues) => {
    this.props.editConta(this.props.match.params.id, formValues);
  };

  render() {
    // console.log(this.props.conta);
    if (!this.props.conta) {
      return <div className="ui active centered inline loader" />;
    }

    return (
      <div className={"ui container"}>
        <div className={"ui grid"}>
          <div className={"ui row"}>
            <div
              className={
                "ui eight wide left aligned column bottom aligned content"
              }
            >
              <h2>Edição de Grupo</h2>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <h5>Identificação</h5>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <Link
                className={"ui mini icon right labeled button"}
                to={"/conta/list"}
              >
                <i aria-hidden="true" className="reply icon" /> Voltar
              </Link>
            </div>
          </div>
        </div>
        <div className={"ui divider"} />
        <ContaForm
          initialValues={_.pick(
            this.props.conta,
            "id",
            "fantasyName",
            "document",
            "socialReason"
          )}
          disable={true}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    conta: state.contas[ownProps.match.params.id],
  };
};

export default requireAuth(
  connect(mapStateToProps, {
    editConta,
    fetchConta,
  })(ContaEdit)
);
